import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import welcomeBg from '@assets/images/welcome.webp';
import pulpWhiteLogo from '@assets/logos/pulp_white.svg';
import { Box, Button, Flex, HeaderItalic, Link, Text } from '@/components/common';
import { analyticsClient } from '@/lib';

/** v90 s-home — welcome with tagline and entry CTAs. */
export function StartPage() {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Box position="relative" height="100%" minHeight="0">
      <img
        src={welcomeBg}
        alt="two people kissing against a wall"
        className="pointer-events-none absolute inset-0 size-full object-cover object-center"
      />
      {/* v90: linear-gradient(180deg, rgba(0,0,0,0.55) 0%, transparent 20%),
            linear-gradient(180deg, transparent 55%, rgba(0,0,0,0.92) 95%) */}
      <div
        className="pointer-events-none absolute inset-0 bg-linear-to-b from-black/55 via-transparent via-20% to-transparent"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-0 bg-linear-to-b from-transparent from-55% to-black/90"
        aria-hidden
      />
      {/* v90: height 55%; to top black 0%/50% → black/40 80% → transparent */}
      <div
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[55%] bg-linear-to-t from-black from-50% via-black/40 via-80% to-transparent"
        aria-hidden
      />

      <Flex
        direction="column"
        justify="between"
        flexGrow="1"
        minHeight="0"
        height="100%"
        px="5"
        py="5"
        pb="6"
        gap="4"
        position="relative"
      >
        <Flex direction="column" align="center" gap="2" pt="6">
          <img className="pulp-logo" src={pulpWhiteLogo} alt="pulp" width={78} />
          <HeaderItalic align="center">{t('welcome.tagline')}</HeaderItalic>
        </Flex>

        <Box>
          <Flex direction="column" gap="3">
            <Button
              type="button"
              onClick={() => {
                analyticsClient.capture('signup_started');
                navigate('/birthday');
              }}
              color="red"
              fullWidth
              size="lg"
            >
              {t('welcome.requestAccess')}
            </Button>
            <Button
              type="button"
              onClick={() => navigate('/login')}
              color="gray"
              highContrast
              fullWidth
              size="lg"
            >
              {t('welcome.signIn')}
            </Button>
          </Flex>
          <Text size="1" color="gray" align="center" mt="4" as="p">
            {tCommon('legal.agreePrefix')}{' '}
            <Link href="/terms" target="_blank" rel="noopener noreferrer">
              {tCommon('legal.terms')}
            </Link>
            . {tCommon('legal.dataPrefix')}{' '}
            <Link href="/privacy" target="_blank" rel="noopener noreferrer">
              {tCommon('legal.privacy')}
            </Link>
            .
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
